import Index from './main.vue'
import { inject } from 'vue'
import { DialogProvider } from './types'

export default Index

export const useMultiDialog = () => {
  const provider = inject<DialogProvider>('multiDialog')

  if (!provider) {
    throw new Error('No outer <DialogProvider /> founded.')
  }
  return provider
}
